import { createFileRoute } from "@tanstack/react-router";
import { FileFormats } from "../../app/helpers/resultUploadHelper";
import Upload from "../../app/views/resultUpload";

const FeedUpload = () => (
  <Upload enabledFormats={[FileFormats.NIR, FileFormats.ICP]} />
);

export const Route = createFileRoute("/feed/upload")({
  component: FeedUpload,
});
